const numberGroupingRegExp = /(-?[\d,.]+)/g;
const nonNumericCharactersRegExp = /[^-\d.]/g;
export const toNumber = (input) => {
    if (typeof input === 'number') {
        return input;
    }
    if (input === null || input === undefined) {
        return NaN;
    }
    const groups = String(input).match(numberGroupingRegExp);
    if (!groups || groups.length !== 1) {
        return NaN;
    }
    return Number(groups[0].replace(nonNumericCharactersRegExp, ''));
};
//# sourceMappingURL=to-number.js.map